import { writable } from 'svelte/store';

export const notificationCount = writable(0);